import styled from 'styled-components';

import { mobile } from '@nw/shared/utils';

import { colors } from '../../../themes/Colors';

export const ContextualLoadingContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${colors['light-blue-gray-50']};
  box-sizing: border-box;
`;

export const ContentWrapper = styled.div`
  max-width: 536px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;

  ${mobile} {
    max-width: 100%;
    padding: 0 16px;
  }
`;

export const MessageTextContainer = styled.div`
  margin-top: 10px;
  min-height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
`;

export const MessageText = styled.p`
  min-height: 40px;
  margin: 0;
  font-family: 'Satoshi';
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: ${colors['light-blue-gray-800']};
  text-align: center;
  white-space: pre-wrap;
  opacity: 0;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  &.fade-in-out {
    animation: fadeIn 0.5s ease forwards;
  }

  &.fade-out {
    animation: none;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
`;
